module.exports = __webpack_public_path__ + "static/media/csv-barns.a4189cd5.svg";